module.exports = __webpack_public_path__ + "static/media/icon-library.dbfc6b8b.jpg";